import { useCallback } from "react";

import { FieldsOption } from "src/base-components/FilterPopover/types";
import { Option, Section, Select } from "src/base-components/Select";
import { Icon } from "src/design-system/Icon";

type FieldsDropdownProps = {
  options: FieldsOption[];
  sections?: Section[];
  dataLoc: string;
  selectedKey: string;
  disabled?: boolean;
  onSelect: (key: string) => void;
};

export const FieldsDropdown: React.FC<FieldsDropdownProps> = ({
  options,
  sections,
  dataLoc,
  selectedKey,
  disabled,
  onSelect,
}) => {
  const buttonRenderer = useCallback(
    (option?: Option) =>
      option ? (
        <span className="flex items-center gap-1.5 truncate">
          {option.icon && <Icon icon={option.icon} size="xs" />}
          <span className="truncate">{option.value}</span>
        </span>
      ) : null,
    [],
  );

  return (
    <Select
      buttonRenderer={buttonRenderer}
      dataLoc={dataLoc}
      disabled={disabled}
      options={options}
      placeholder="Select field"
      sections={sections}
      value={selectedKey}
      onChange={onSelect}
      searchable
      searchPlaceholder="Search fields"
    />
  );
};
